import { render, staticRenderFns } from "./PartnerBannersView.vue?vue&type=template&id=eb91d04e&scoped=true"
import script from "./PartnerBannersView.vue?vue&type=script&lang=ts"
export * from "./PartnerBannersView.vue?vue&type=script&lang=ts"
import style0 from "./PartnerBannersView.vue?vue&type=style&index=0&id=eb91d04e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb91d04e",
  null
  
)

export default component.exports